import { useSearchRolesQuery } from 'domains/account-management/api'

export const useRoleById = (roleId: string) => {
  const { data, loading, error } = useSearchRolesQuery({
    variables: { roleId: roleId },
    skip: !roleId,
  })
  const role = data?.roleSearch && data.roleSearch.length > 0 && data.roleSearch[0]

  return { role, loading, error }
}
